// DropdownContext.js
import React from "react";

const DropdownContext = React.createContext({
  selectedColor: "",
});

export default DropdownContext;
